import React from "react";
import Select from "../Select";
import Icon from "../Icon";

const SKILL_LABELS = { listening: "Listening", speaking: "Speaking", vocabulary: "Vocabulary" };

function modeOptions(skill, isTranslateAvailable) {
  const options = [["multiple_choice", "Multiple Choice"], ["text_input", "Text Input"]];
  if(skill === "vocabulary") options.splice(1, 0, ["flashcard", "Flashcards"]);
  if(skill === "listening") options.push(["full_text_input", "Transcribe"]);
  if(skill === "vocabulary" && isTranslateAvailable) options.push(["full_text_input", "Translate"]);
  return options;
}

// Like the app's gameplay settings: only speaking, or app-only vocabulary modes on another skill, change the mode.
export function modeAfterSkillChange(skill, mode) {
  const isVocabularyOnlyMode = mode === "flashcard" || mode === "sentence_builder";
  return skill === "speaking" || (skill !== "vocabulary" && isVocabularyOnlyMode) ? "multiple_choice" : mode;
}

export function modeForSkill(skill, mode, isTranslateAvailable) {
  if(skill === "speaking") return "text_input";
  return modeOptions(skill, isTranslateAvailable).some(([value]) => value === mode) ? mode : "multiple_choice";
}

const Field = ({ children, label, labelExtra = null }) => (
  <div className="tw-flex tw-items-center tw-justify-between tw-gap-4">
    <label className="text-secondary" style={{ margin: 0 }}>{label}{labelExtra}</label>
    {children}
  </div>
);

const SkillInfoButton = ({ onClick }) => (
  <button aria-label="learning methods info" className="btn btn-link btn-xs" onClick={onClick} type="button">
    <Icon name="info-circle" type="fa" />
  </button>
);

export function SkillSelect({ isListeningAvailable, isSpeakingAvailable, onChange, onInfoClick = null, skill, testId }) {
  const skills = ["vocabulary", isListeningAvailable && "listening", isSpeakingAvailable && "speaking"].filter(Boolean);
  return (
    <Field label="Skill" labelExtra={onInfoClick && <SkillInfoButton onClick={onInfoClick} />}>
      <Select data-testid={testId} onChange={(e) => onChange(e.target.value)} style={{ width: "auto" }} value={skill}>
        {skills.map((value) => <option key={value} value={value}>{SKILL_LABELS[value]}</option>)}
      </Select>
    </Field>
  );
}

export function ModeSelect({ isTranslateAvailable, mode, onChange, skill, testId }) {
  if(skill === "speaking") return null;
  return (
    <Field label="Mode">
      <Select data-testid={testId} onChange={(e) => onChange(e.target.value)} style={{ width: "auto" }} value={modeForSkill(skill, mode, isTranslateAvailable)}>
        {modeOptions(skill, isTranslateAvailable).map(([value, label]) => <option key={value} value={value}>{label}</option>)}
      </Select>
    </Field>
  );
}

export function NumberField({ label, min, onCommit, testId, value }) {
  const [localValue, setLocalValue] = React.useState(String(value));
  const parsed = parseInt(localValue, 10);
  const isInvalid = localValue !== "" && (isNaN(parsed) || parsed < min);

  React.useEffect(() => setLocalValue(String(value)), [value]);

  const commit = () => {
    if(!isNaN(parsed) && parsed >= min) {
      onCommit(parsed);
    } else {
      setLocalValue(String(value));
    }
  };

  return (
    <div>
      <Field label={label}>
        <input
          className="form-control"
          data-testid={testId}
          min={min}
          onBlur={commit}
          onChange={(e) => setLocalValue(e.target.value)}
          style={{ textAlign: "center", width: 72 }}
          type="number"
          value={localValue}
        />
      </Field>
      {isInvalid && <div className="text-danger text-right"><small>Enter a number greater than 0</small></div>}
    </div>
  );
}
